import { render } from "./WorkspaceFooter.vue?vue&type=template&id=553e2538"
import script from "./WorkspaceFooter.vue?vue&type=script&lang=js"
export * from "./WorkspaceFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__